import React from 'react'
import { connect } from 'react-redux'
import Modal from '../../../components/modal/modal.component.jsx'
import FontAwesome from 'react-fontawesome'
import PriceOption from './price-option/price-option.container'
import ReactTooltip from 'react-tooltip'
import ModalConfirmation from './../../../components/modal/modal-confirmation.component'
import { routes } from './../../../constants/routes.constants'
import { history } from './../../../helpers/history'
import {
	StyledContainer,
	StyledDeparture,
	StyledBannerContainer,
	StyledButtonContainer,
	StyledPricesContainer,
	StyledPromotionUserMessage,
	StyledBusPromotionMessage,
	StyledDestination,
	StyledBoxDestination,
	StyleViagens
} from './trip-option-components'
import Button from '../../../components/buttons/buttons.component'
import banner from '../../../../assets/images/cupom-promocional/image002.png'
import Moment from 'moment'
import { userConstants } from '../../../constants'
import { PRIMARY_COLOR } from '../../../styles/colors.style'
import TripLine from './trip-line/trip-line.component.jsx'

const self = {
	chosenPrice: {},
	onPriceSelect: () => 0,
	modalUpgradeContent: ''
}

class TripOptionObject extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			isModalOpen: false,
			isUpgradeModalOpen: false,
			isInsufficientPointsModalOpen: false
		}
	}

	setIsModalOpen = isModalOpen => {
		this.setState({ isModalOpen })
	}

	setUpgradeModalOpen = isUpgradeModalOpen => {
		this.setState({ isUpgradeModalOpen })
	}

	setInsufficientPointsModalOpen = isInsufficientPointsModalOpen => {
		this.setState({ isInsufficientPointsModalOpen })
	}

	onResult = confirmed => {
		this.setIsModalOpen(false)
		if (confirmed) history.push(`${routes.CLIENTE}/planos`)
	}

	onInsufficientPointsResult = confirmed => {
		this.setInsufficientPointsModalOpen(false)
		if (confirmed) history.push('compra-de-pontos')
	}

	onUpgradeClose = () => {
		this.setUpgradeModalOpen(false)
		self.onPriceSelect(self.chosenPrice)
	}

	showUpgradeModal = (
		onPriceSelect,
		chosenPrice,
		promotionMessage,
		busCompany
	) => {
		self.chosenPrice = chosenPrice
		self.onPriceSelect = onPriceSelect
		self.modalUpgradeContent = buildUpgradeModalContent(
			chosenPrice,
			onPriceSelect,
			setUpgradeModalOpen,
			setInsufficientPointsModalOpen,
			promotionMessage,
			busCompany
		)
		this.setUpgradeModalOpen(true)
	}

	render() {
		const {
			user,
			origin,
			arrival,
			raceDate,
			busClass,
			isOnFire,
			onSelect,
			className,
			departure,
			freeSeats,
			promotion,
			busCompany,
			canUpgrade,
			destination,
			showFreeSeats,
			formattedDiff,
			promotionPercent,
			ehConexao,
			conexao,
			noBusChange,
			rebookingData
		} = this.props

		const isRequester = user && user.isRequester
		const isPublicBody = user && user.hasPublicBody

		if (!busCompany) {
			return null
		}

		let parceiro = busCompany.toLowerCase()

		Moment.locale('pt-br')

		const PriceOptions = () => {
			const isSubscriber =
				user &&
				user.plan &&
				user.plan.status.toUpperCase() == userConstants.ACTIVE

			const { prices } = this.props

			const pricesOptions = prices.filter(price => {
				const isSubscriberPrice = price.forSubscribers === !!isSubscriber
				const isPublicBodyPrice =
					!user || !user.hasPublicBody || price.points === 0
				//const isRebookingPrice = false
				//const isRebookingPrice = !rebookingData.isRebooking || !price.points
				const isRebookingPrice = !price.points

				// return isSubscriberPrice && isPublicBodyPrice && isRebookingPrice
				return isSubscriberPrice && isPublicBodyPrice
			})

			return pricesOptions.map((price, index) => (
				<PriceOption
					key={index}
					price={price}
					onSelect={onSelect}
					busCompany={busCompany}
					canUpgrade={canUpgrade}
					raceDate={raceDate}
					promotionPercent={promotionPercent}
					showUpgradeModal={this.showUpgradeModal}
					setInsufficientPointsModalOpen={
						this.setInsufficientPointsModalOpen
					}
					pricesLength={pricesOptions.length}
					setIsModalOpen={this.setIsModalOpen}
				/>
			))
		}

		return (
			<StyledContainer className={`${className} trip-option-${busClass}`}>
				<StyledDestination>
					<StyledBoxDestination>
						<StyledDeparture>
							<div className="row-image">
								<div>
									<img
										className="partner-logo"
										src={`../../../assets/static/logo-${parceiro}.png`}
									/>
								</div>
								<div>
									<img
										data-for="icons-tooltip"
										data-class="icons-tooltip"
										data-tip
										src="../../../assets/static/qr-code.png"
										alt="Passagem Digital"
									/>
								</div>
								<div>
									<img
										data-for="icons-tooltip"
										data-class="icons-tooltip"
										data-tip
										src="../../../assets/static/security.png"
										alt="Segurança Reforçada"
									/>
								</div>
								{showFreeSeats && (
									<div
										className={`bus-seats bus-seats${
											isOnFire ? '-on-fire' : '-normal'
										}`}>
										<img
											src={`../../../assets/static/bus-seats${
												isOnFire ? '-fire' : ''
											}.png`}
											alt="Lugares livres restantes"
										/>
										<span>
											{freeSeats} Lugar{freeSeats == 1 ? '' : 'es'}{' '}
											restantes
										</span>
									</div>
								)}
								{!showFreeSeats && (
									<div
										style={{ visibility: 'hidden' }}
										className={`bus-seats bus-seats${
											isOnFire ? '-on-fire' : '-normal'
										}`}>
										<img
											src={`../../../assets/static/bus-seats${
												isOnFire ? '-fire' : ''
											}.png`}
											alt="Lugares livres restantes"
										/>
										<span>
											{freeSeats} Lugar{freeSeats == 1 ? '' : 'es'}{' '}
											restantes
										</span>
									</div>
								)}
							</div>
							<ReactTooltip
								id="icons-tooltip"
								aria-haspopup="true"
								effect="solid"
								place="right">
								<div className="tooltip-title tooltip-title-digital-ticket">
									<div>
										<img
											src="../../../assets/static/qr-code.png"
											alt="Passagem Digital"
										/>
										Passagem digital
									</div>
								</div>

								<p>
									Receba a passagem no celular para apresentar direto
									no embarque!
								</p>
								<div className="tooltip-title tooltip-title-enhanced-security">
									<div>
										<img
											src="../../../assets/static/security.png"
											alt="Segurança Reforçada"
										/>
										Segurança Reforçada
									</div>
								</div>
								<p>
									Este selo indica que a viação está comprometida com o
									bem-estar de seus passageiros, seguindo rigorosos
									padrões de higiene e medidas de segurança em todas as
									viagens.
								</p>
							</ReactTooltip>

							<div className="row-destination">
								<div className="row-destination-container">
									<div className="box-time">
										<div className="departure">
											<p className="time">{departure}</p>
											<small>{origin}</small>
										</div>
										<div className="duration">
											<span className={'bus-class'}>
												<FontAwesome
													name="bus"
													className="fa-icon"
												/>{' '}
												{noBusChange ? (
													<span>
														CONEXÃO{' '}
														<span className="bus-class-no-bus-change">
															SEM TROCA DE ÔNIBUS
														</span>
													</span>
												) : (
													busClass
												)}
											</span>

											{/* Altera linha para quando for conexão */}
											{ehConexao && <TripLine qttTrips={1} />}
											{!ehConexao && <TripLine qttTrips={0} />}

											<cite
												data-for="duration-tooltip"
												data-tip="true"
												data-multiline="true"
												data-html="true"
												data-class="duration-tooltip">
												<em>
													<FontAwesome name="clock-o" />{' '}
													{formattedDiff}
												</em>
											</cite>
											<span className="about-time-message">
												Tempo estimado de duração de viagem
											</span>

											<ReactTooltip
												id="duration-tooltip"
												aria-haspopup="true"
												effect="solid"
												place="bottom">
												Duração da Viagem. Esta informação é apenas
												para efeito de orientação e não deve ser
												utilizada para compromissos agendados, pois,
												trata-se de apenas uma previsão do tempo de
												viagem até o destino.
											</ReactTooltip>
										</div>
										<div>
											<p className="time">{arrival}</p>
											<small>{destination}</small>
										</div>
									</div>
								</div>
							</div>
						</StyledDeparture>
					</StyledBoxDestination>
					<div className="box-assinante">
						<StyledPricesContainer>
							<div className={`row ff-fix-first-child row-${busClass}`}>
								<div className={`price-card-column row-${busClass}`}>
									<div
										className={`prices-container ${
											!isPublicBody && !isRequester && promotion
												? 'with-promotion'
												: ''
										}`}>
										{!isPublicBody && !isRequester && promotion && (
											<StyledBusPromotionMessage
												data-for="promotionpercent-tooltip"
												data-tip="true"
												data-multiline="true"
												data-html="true"
												data-class="promotionpercent-tooltip">
												<span>
													{Math.trunc(promotionPercent)}% OFF
												</span>
												<ReactTooltip
													id="promotionpercent-tooltip"
													aria-haspopup="true"
													effect="solid"
													place="bottom">
													Tarifa com desconto somente para
													poltronas promocionais de acordo com
													disponibilidade.
												</ReactTooltip>
											</StyledBusPromotionMessage>
										)}
										<div className="prices-header">
											Selecione uma forma de pagamento
										</div>
										<div
											className={`price-buttons row-${busClass} buttons-${busClass}`}>
											<PriceOptions />
										</div>
									</div>
								</div>
							</div>
						</StyledPricesContainer>
					</div>
				</StyledDestination>
				{ehConexao && (
					<div style={{ justifyContent: 'inherit', width: '100%' }}>
						<hr
							style={{
								borderTop: '1px dashed',
								color: '#fbdbb8',
								border: '2px solid',
								borderWidth: '5px 0px 0px 0px',
								borderStyle: 'dashed'
							}}></hr>
						<StyleViagens>
							<ul className="timeline">
								{conexao.trecho.map((viagem, index) => (
									<li key={index}>
										{' '}
										<strong>{viagem.origem}</strong>
										{'   '}
										<FontAwesome
											style={{ color: PRIMARY_COLOR }}
											name="bus"
											className="fa-icon"
										/>
										{'   '}
										<strong>
											{' '}
											{viagem.destino} - {viagem.busClass}{' '}
										</strong>
										<span>
											{' '}
											(VIAÇÃO {viagem.enterpriseNormalized}){' '}
										</span>{' '}
										-{' '}
										{Moment(viagem.departure).format(
											'DD/MM/YYYY HH:mm'
										)}{' '}
										—{' '}
										{Moment(viagem.arrival).format(
											'DD/MM/YYYY HH:mm'
										)}
									</li>
								))}
							</ul>
						</StyleViagens>
					</div>
				)}
				<ModalConfirmation
					onResult={this.onResult}
					isOpen={this.state.isModalOpen}
					title="Clube Muviflex">
					A opção de preço selecionada é exclusiva para assinantes do Clube
					Muviflex. Deseja conhecer as vantagens do Clube Muviflex?
				</ModalConfirmation>
				<ModalConfirmation
					buttonNoText="Agora não"
					title="Compra de passagem"
					onResult={this.onInsufficientPointsResult}
					buttonYesText="Comprar pontos"
					isOpen={this.state.isInsufficientPointsModalOpen}>
					Saldo de pontos insuficiente. Deseja comprar pontos?
				</ModalConfirmation>
				<Modal
					title=""
					medium
					isOpen={this.state.isUpgradeModalOpen}
					onClose={this.onUpgradeClose}>
					<StyledBannerContainer>
						<img className="upgrade-image" src={banner} />
					</StyledBannerContainer>
					{self.modalUpgradeContent}
					<StyledButtonContainer>
						<Button link onClick={this.onUpgradeClose}>
							Não, obrigado
						</Button>
					</StyledButtonContainer>
				</Modal>
			</StyledContainer>
		)
	}
}

const buildUpgradeModalContent = (
	{ upgradePrices, forSubscribers, upgradeBusClass },
	onPriceSelect,
	setUpgradeModalOpen,
	setInsufficientPointsModalOpen,
	promotionMessage,
	busCompany
) => {
	const prices = upgradePrices
		.filter(price => price.forSubscribers == forSubscribers)
		.map((price, index) => (
			<PriceOption
				key={index}
				price={price}
				busCompany={busCompany}
				onSelect={() => {
					setUpgradeModalOpen(false)
					onPriceSelect(price, true)
				}}
				setInsufficientPointsModalOpen={setInsufficientPointsModalOpen}
			/>
		))

	return (
		<StyledPricesContainer>
			<span className="upgradeBusClass">
				<span aria-hidden="true" className="fa fa-bus fa-icon" />
				{upgradeBusClass}
			</span>
			<div className="row">{prices}</div>
			{promotionMessage && (
				<StyledPromotionUserMessage>
					{promotionMessage}
				</StyledPromotionUserMessage>
			)}
		</StyledPricesContainer>
	)
}

const mapStateToProps = store => ({
	user: store.user,
	rebookingData: store.ticketSale.rebookingData
})
const TripOption = connect(mapStateToProps, null)(TripOptionObject)
export default TripOption
